import type { RegionState } from './types';

// this would be the other way of handling actions for the reducer without the union and import()
// call in the type itself, although this method may affect the auto import results
// export { changeUser } from '#/reduxState/currentUser/currentUserReducer';

export const setRestrictedRegion = (
  restrictedRegion: RegionState['restrictedRegion']
) =>
  ({
    type: 'REGION_SET_RESTRICTED_REGION',
    payload: { restrictedRegion },
  }) as const;
